<!-- filepath: e:\Git\bang-inc\frontend\src\components\Breadcrumb.vue -->
<template>
    <nav class="breadcrumb">
        <template v-for="(item, index) in items" :key="index">
            <NuxtLink v-if="item.href && index < items.length - 1" :to="item.href" class="breadcrumb-link">
                {{ item.text }}
            </NuxtLink>
            <span v-else class="breadcrumb-current">{{ item.text }}</span>
            <span v-if="index < items.length - 1" class="breadcrumb-separator">
                ＞
            </span>
        </template>
    </nav>
</template>

<script setup lang="ts">
interface BreadcrumbItem {
    text: string;
    href?: string;
}

defineProps<{
    items: BreadcrumbItem[];
}>();
</script>

<style scoped lang="scss">
.breadcrumb {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    font-weight: 400;
    padding: 0.5rem 0;
}

.breadcrumb-link {
    color: #2174C0;
    text-decoration: underline;

    &:hover {
        opacity: 0.48;
        transition: opacity 0.3s ease;
    }
}

.breadcrumb-separator {
    margin: auto 0.25rem;
    color: #252522;
}

.breadcrumb-current {
    color: #252522;
}

// PC用のスタイル
@include mixin.media(pc) {}
</style>